import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfHeading = ({ data }: Props) => {
  const { content } = data;

  return <h2 className="text-xl scroll-mt-16 px-2 ">{content}</h2>;
};
